var MainMenu = (function() {

    //console.log($(window).width());

    var $listItems = $( '#primary-nav > ul > li > div.nav-toggler' ),
        $menuItems = $listItems.children( 'a.menu-open' ),
        $body = $( 'body' ),
        current = -1;


    function init() {

        //if ($(window).width() < 1025) 
        //{
            $menuItems.on('click', open );
        //};

    }

    function open( event ) {


        var $item = $( event.currentTarget ).closest( 'li' ),
            idx = $item.index();


        // no children
        if(($item).children('div.sub').length == 0) return true;
        // helper class
        if($item.hasClass('logo')) return true;

        // already on
        if( current === idx ) 
        {
            $item.children('div.sub').css('display', 'none');
            current = -1;
        }
        else 
        {
            $listItems.children('div.sub').css('display', 'none');
            $item.children('div.sub').css('display', 'block');
            current = idx;
            //$body.off( 'click' ).on( 'click', close );
        }

        return false;

    }

    return { init : init };

})();

$(function() {
    MainMenu.init();
});


function toggleMobileMenu() 
{
    $("html").toggleClass('nav-is-open');
    $("nav.primary").toggleClass('nav-open');
    $(".nav__container").toggleClass('nav-open');
    if ($("nav.primary").hasClass('nav-open'))
    {
        $("#menutext").html("CLOSE");
        $("#menutext").addClass("extrac");
    }
    else
    {
       $("#menutext").html("MENU"); 
       $("#menutext").removeClass("extrac");
    }

}

$(".mobile-menu-controller").on('click', function(e) 
{
    e.preventDefault();
    toggleMobileMenu();
});

$( '.mobile-search [type="submit"]').on('click', function(e) {
    toggleMobileMenu();
});